<div class="tab-pane" uib-tab-content-transclude="tab">
  <app-dealer-query-reports-view *appHasAnyAuthority="['QUERY_REPORT', 'INDUSTRY_REPORT']" [profile]="profile"></app-dealer-query-reports-view>
</div>
